import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function loadServiceInitiation(serviceInitiationId = '') {
  return axiosRequest('get', serviceUrls.SERVICEINIT_LOADINITIATION, { serviceInitiationId });
}

export function fetchNewServiceInitiation() {
  return axiosRequest('get', serviceUrls.SERVICEINIT_NEW, {}, { timeout: 180000 });
}

export function saveNewServiceInitiation(body = {}) {
  return axiosRequest('post', serviceUrls.SERVICEINIT_SAVE, body);
}

export function fetchServiceInitiationFilters() {
  return axiosRequest('get', serviceUrls.SSI_GET_FILTERS);
}

export function fetchServiceInitiations(params, config) {
  return axiosRequest('post', serviceUrls.SSI_GET_LIST, params, config);
}

export function fetchNewEmployeeFormData(params, config) {
  return axiosRequest('get', serviceUrls.SERVICEINIT_CREATE_NEWEMPLOYEE, params, config);
}

export function saveEmployeeFormData(params, config) {
  return axiosRequest('post', serviceUrls.SERVICEINIT_SAVE_NEWEMPLOYEE, params, config);
}

export function fetchServiceInitiationPolicies(id, config) {
  return axiosRequest('get', serviceUrls.SERVICEINIT_POLICIES.replace('%id%', id), config);
}

export function saveServiceInitiationPolicies(id, params, config) {
  return axiosRequest('post', serviceUrls.SERVICEINIT_POLICIES.replace('%id%', id), params, config);
}

export function uploadBatchServiceInitiations(data) {
  return axiosRequest('post', serviceUrls.SERVICEINIT_BATCH_UPLOAD, data);
}

export function downloadTemplateAPI() {
  return axiosRequest('post', serviceUrls.SERVICEINIT_BATCH_DOWNLOADTEMPLATE, null, { responseType: 'arraybuffer' });
}

export function getBatchInitProgressAPI(params, config) {
  return axiosRequest('get', serviceUrls.SERVICEINIT_BATCH_PROGRESS, params, config);
}
